/*
 * Action Types
 */
export enum DatesTypes {
  SET_SELECTED_IS_STARTED_AT = '@dates/IS_STARTED_AT',
  SET_SELECTED_STARTED_AT = '@dates/STARTED_AT',
  SET_SELECTED_START_DATE = '@dates/SELECTED_START_DATE',
  SET_SELECTED_END_DATE = '@dates/SELECTED_END_DATE',
}

/*
 * State type
 */
export interface DatesState {
  readonly isStartedAt: Date;
  readonly startedAt: Date;
  readonly selectedStartDate: Date;
  readonly selectedEndDate: Date;
  readonly loading: boolean;
  readonly error: boolean;
}
